module.exports = {
  // / DURING PROD OR STAGGINF BUILD WE HAVE TO CHANGE THE BASEURL MANUALLY IN  /

  //==================STAGING================================ //
  // configbaseUrl: "http://staging.watsoo.com:8085/client-config",
  //  =============================================================

  // ===========================PRODUCTION===========================

  configbaseUrl: "https://ais.watsoo.com/ais-config/config",
  // geofenceBaseUrl: "https://aisstaging.watsoo.com/ais-notification/",

  // Add new base URLs for different services
  // driverServiceBaseUrl: "https://aisstaging.watsoo.com", // Remove /driver-service/api from here
  // vehicleDocumentServiceBaseUrl: "http://192.168.30.35:9797", // Add this if needed

  /* =================================================================== */
  Username: "admin",
  // Password:'rapid#2021',
  Password: "admin",

  apiKey: "AIzaSyD5y7I25p_GnEpt_mcLV30lLJGbpmDU6Dw", // production
  // apiKey: "AIzaSyA5Lt3E5gYb-lfogvaSpCrvCpocLqHwNOI", // staging
  // apiKey: "AIzaSyDL9J82iDhcUWdQiuIvBYa0t5asrtz3Swk",
  MAP_ID: "4ebc5c802610e4ce2cfe74b4",
  NkcWeb: true,
  // VTSWeb:false,
  // BJBWeb:false,
  version: 22.002,
  localhost: "fmsstaging",

  // Api endpoint name
  apiName: {
    SubUsersVehicleList: "api/user-vehicle/notify",
    kycAllApprove: "api/v1/approve/all/kyc/documents",
    kycApproval: "api/v1/approve/kyc/documents",
    getTrail: "api/v1/get/kyc/documents",
    saveKyc: "api/v1/save/kyc/documents",
    // fileUpload: "https://storage.nyggs.com/s.vehiclelistetmedia/api/save/file",
    fileUpload: "https://storage.nyggs.com/setmedia/api/save/file",
    getKycDetails: "api/v1/check/existing/vendor",
    getKycTypes: "api/v1/documents/all",
    setDefaultDashboard: "api/v1/setUserDefaultDashboard",
    getVehicleDetails: "v1/getFuelDashboard",
    companyList: "api/v1/company/all",
    addNewCompany: "api/v1/company/add",
    AddChainage: `api/v1/import/excelFile`,
    AddPolyline: "/api/v2/import/excelFile",
    GetLatLngBySite: "api/v1/siteConstruction/Order",
    UploadFileOnAWs: "uploadFile",
    loginApi: "v3/login",
    UserList: "api/v1/user/all",
    AddUser: "api/v1/user/add",
    ActiveUser: "api/v1/user/active/inactive",
    UpdateUser: "api/v1/user/update",
    GetUserById: "api/v1/user",
    DesignationList: "v1/designation",
    permission_category: "v1/permission_category",
    RoleList: "v1/role/all",
    SiteList: "api/v1/site/all",
    AddSiteAccess: "api/v1/add/user/site/role",
    RemoveSiteAccess: "api/v1/remove/user/site/role",
    AddRole: "v1/role/add",
    VehicleList: "api/v4/vehicle/all",
    VehicleListV6: "api/v6/vehicle/all",
    VehicleTypeList: "api/v1/all/vehicle-type",
    importKycExcel: "api/v1/import/kyc/excel",
    ActiveVehicle: "api/v1/vehicle/active/inactive",
    AddVehicle: "api/v1/vehicle/add",
    VehicleById: "api/v1/vehicle/view",
    VehicleByIdV2: "api/v2/vehicle/view",
    UpdateVehicle: "api/v1/vehicle/update",
    VendorList: "api/v1/vendor/all",
    AddVendor: "api/v1/vendor/add",
    UpdateVendor: "api/v1/vendor/update",
    VendorById: "api/v1/vendor/view",
    ActiveVendor: "api/v1/vendor/active/inactive",
    DriverList: "api/v1/driver/all",
    DocumentList: "api/v1/documents/all",
    RouteList: "api/v1/route/all",
    AddRoute: "api/v1/route/add",
    ActiveRoute: "api/v1/route/active/inactive",
    RouteById: "api/v1/route/id",
    UpdateRoute: "api/v1/route/update",
    SyncVehicle: "api/v1/sync/vehicle",
    DeleteFile: "deleteFiles",
    EtpOrder: "api/v1/etp/orders/view",
    TotalVendorDashboard: "api/v1/dashbord/status",
    fetchAddress: "address/v1/fetch_address",
    totalInstallGps: "api/v1/dashbord/vehicle/status",
    removeGeoFench: "api/v1/delete/geofence",
    CreateTrip: "api/v1/etp/orders/create",
    TripList: "api/v2/etp/orders/get/all",
    MaterialType: "api/v1/all/material-type",
    DestinationTripSite: "api/v1/get_destinations_from_source",
    ViewTrip: "api/v1/etp/orders/view",
    NotificationAlert: "api/v1/alert/get_all",
    KmlFileUploding: "api/uploadKmlData",
    getFuelDashboard: "getFuelDashboard",
    routeSiteSubSite: "api/v1/site/route/sub_site/all",
    removeGpsFromVehicle: "api/v1/remove/vehicle",
    routeDetele: "api/v1/route/delete",
    loginLog: "api/v1/auditLog",
    auditLog: "api/v2/getall/auditLog",
    AllpermissionName: "api/v1/permission",
    ActiveRoutes: "api/v1/get/active/routes",
    UptimeReport: "api/v1/vehicle/active/inactive/history",
    DieselValue: "api/saveFuelPrice",
    GetNotificationList: "api/v1/get/all/notification/configuration",
    GetDetailList: "api/v1/get/notification/configuration",
    AddNotification: "api/v1/create/notification/configuration",
    EditNotification: "api/v1/edit/notification/configuration",
    NotificationType: "api/v1/get/notification/type",
    AllRemarksShowDetails: "v1/get/all/fuel/droppage/alert/remark",
    Addremarks: "v1/save/fuel/droppage/alert/remarks",
    AllRemarksShowDetails1: "v1/get/all/wire/cut/alert/remark",
    Addremarks1: "v1/save/wire/cut/alert/remarks",
    clientDataFromApi: "/api/get/company/config",
    VehicleStatusList: "v1/get/all/fuel/status?type=DEVICE_FUEL_DROP",
    DieselRequestList: "v1/get/fuel/fill/request",
    DieselRequestCreate: "v2/fuel/fill/request/create",
    DieselRequestApprove: "v1/fuel/fill/request/update",
    DieselRequestIssue: "v1/fuel/fill/request/issue",
    DirectIssueRequest: "v1/fuel/fill/direct/issue/request/create",
    DieselIssuedSync: "v1/fuel/fill/request/manual/sync",
    // DiselStatausList:"api/get/fuelFillRequest?pageSize=1&pageNo=1"
    // DiselStatausList:"api/get/fuelFillRequest?pageSize=1&pageNo=1",
    MenuList: "api/v1/menu/master/getAll",
    SubmenuList: "api/v1/get/all/submenu/master",
    Rolelist: "api/v1/get/allRole",
    savemenusubmenus: "api/v1/save/user/menu/submenu/map/data",
    // subusers endpoints
    SubUsersList: "api/v2/Subuser/all",
    SubUsersListLite: "api/v2/subuser/all/lite",
    AddSubUser: "api/v2/Subusers/add",
    SubUserById: "api/v2/subUser/byId",
    UpdateSubUser: "api/v2/subUser/update",
    // user vehicle mapping
    vehicleAddForAccess: "api/user/vehicles/details/add",
    existingVehicleAccess: "api/v2/get/user/vehicles/details",
    deleteVehicles: "api/user/vehicles/details/update",
    //vehicle Add
    addVehiclessave: "api/v2/vehicle/add",
    UpdateVehicles: "api/v2/vehicle/update",
    // certificatedata: "api/v1/getVehicleBy/certificateNo",
    certificatedata: "api/v2/getVehicleBy/certificateNo",

    vtsModelList: "api/v1/getBy/companyId",
    // vtsModelList: "api/v2/getBy/companyId",

    // Logo Add
    LogoUrl: "api/v1/update/delerLogo",
    cangepassword: "v2/change/password",
    vehiclesAllActivationList: "get/all/activation/request",

    //getAllDealerBalanceSheet: "api/v1/get/all/dealer/balance/sheet",

    getDealerLedgerById: "api/get/trans/dealer",
    getAllActivationRenewalRequests: "api/activation-renewal-requests/getAll",
    bulkUpdateActivationRenewal:
      "api/activation-renewal-requests/import/support/device/request",
    getAllActivationRenewalListToUpdate:
      "api/activation-renewal-requests/support/device/request",
    updateSingleVehicleDate:
      "api/activation-renewal-requests/support/device/request/update",
    subcruptionList: "api/dealer-subscriptions/getAll",
    viewsubcruption: "api/subscription-master/getAll",
    createsubscriptions: "api/dealer-subscriptions/create",
    updatesubscriptions: "api/dealer-subscriptions/update",
    getDealerSubscriptionbyID: "api/dealer-subscriptions/getById",
    getAllDealerBalanceSheet: "api/v1/get/all/dealer/balance/sheet",
    // getDealerLedgerById: "api/get/trans/dealer",
    // getAllActivationRenewalRequests:"api/activation-renewal-requests/getAll",
    approver: "",
    getByIdActivation: "api/activation-renewal-requests/getById",
    createaCtivationRenewal: "api/activation-renewal-requests/create",
    paymentMethode: "api/dealer/payment",
    dealearByVewPayment: "api/get/dealer/current-balance",
    AprrovedActivation: "api/activation-renewal-requests/apporve",
    currentBalance: "api/get/dealer/current-balance",
    addVehicleWithExcelOrMultiSelect: "api/import/user/vehicle",
    resetPassword: "v1/reset/password",
    forgotPassword: "v1/reset/password/link",
    newDashboardData: "api/v1/get/newDashboardData",
    commandsList: "api/v1/commands",
    commandShoot: "api/v1/command/shoot",
    getAllUserPermission: "api/user-type-menu/get/all/1",
    savePermission: "api/user-type-menu/save/mapconfig",
    geofenceList: "v1/get/user/geofences",
    getGeofenceById: "v1/get/geofence",
    addGeofence: "v1/add/geofence",
    updateGeofence: "v1/update/geofence",
    deleteGeofence: "v1/delete/geofence",
    geofenceNotifTypeUpdate: "v2/save/user/based/notifications",
    geofenceDeviceList: "v2/get/device/geofence",
    getAllNotification: "api/get/mstr/notification",
    updateMaterNotification: "api/manage/notificationV2",
    deactivateGeofence: "v1/deactivate/user/notification",
    maintenanceVehicleList: "api/v1/vehicle/maintenance/category",
    dailyDistanceReport: "api/v1/get/reports/page/data",
    maxDeviceLimit: "api/get/reports/data/export/config",
    getPublicAddressList: "public/get/address/list",
    updateGeofenceAuthPerson: "v2/update/geofence",
    rebootDigilock: "lock/dashboard/reboot/lock",
    getReportRemarks: "public/v1/reports/status-remarks",
    updateVehicleImage: "api/v1/update/vehicle/image",
    updateProfilePicture: "api/v1/update/user/profile/picture",
    historyTimeline: "api/v1/get/journey/timeline",
    // ==============================stats-dashboard======================
    statsDashboardUrl: "api/new/mobile/dashboard/vehicle/status",
    statsDashboardAlertsUrl: "/api/get/all/push/notify",
    newDashboardCountUrl: "api/v1/get/dashboard/vehiclestatuswise/count",
    statsDashboardParkingData: "api/v1/get/parking/dashboard/status",
    weekWiseComparisonGraphData: "api/v1/get/weekly/dashboard/status",
    overUtilizedLocksData: "lock/dashboard/v1/lock-utilization/over",
    underUtilizedLocksData: "lock/dashboard/v1/lock-utilization/under",
    fuelUtilizationDashboard: "fuel-service/api/v1/fuel/dashboard/summary",
    fuelDashboardTrend: "fuel-service/api/v1/fuel/dashboard/trend",
    topDroppageVehicles: "fuel-service/api/v1/fuel/dashboard/top-droppage",
    secureVehicles: "fuel-service/api/v1/fuel/dashboard/secure-vehicles",
    fuelVehicleStatusDashboard: "fuel-service/api/v1/fuel/vehicles/status",
    FmsFuelGraphBase: "fuel-service/api/v1/fuel/graph",
    FmsDashboardReport: "fuel-service/api/v1/fuel/report/dashboard",
    FmsExportExcel: "fuel-service/api/v1/fuel/report/export/excel",
    FmsExportPdf: "fuel-service/api/v1/fuel/report/export/pdf",

    // ==============================Driver & Vehicle Services======================
    driverDashboard: "api/drivers/dashboard",
    driverDocumentExpiryReport: "api/drivers/document-expiry-report",
    vehicleDocumentDashboard: "api/vehicle-document/dashboard",
    relayStatusUpdate: "api/vehicle/relay/status/update",

    tableHeadersVisibility: "v1/get/user-wise/header/config",
    updateTableHeadersVisibility: "v1/update/user-wise/header/config",
    disengageVehicle: "api/disengage/vehicle",
    oldReportData: "raise/issue/ticket",
    getDriversScoreCard: "v1/driver-scorecard/get",
    getDriversScoreCardDistanceEvents: "api/drivers/calculate/trip-distance",
    getDriversSafetySummary: "api/drivers/driver-safety-summary",
    getDriversSafetyTrend: "v1/driver-scorecard/get/safety/trend",

    // ============================Territory And Zone Management===========
    getAllRegions: "api/get-all/regions/by/userId",
    createRegion: "api/create-region",
    updateRegion: "api/update-region",

    createZone: "api/create-zone",
    updateZone: "api/update-zone",
    getAllZones: "api/get-all/zones/by/regionId",

    createArea: "api/create-area",
    updateArea: "api/update-area",
    getAllArea: "api/get-all/areas/by/zoneId",
    getVehiclesByArea: "api/vehicles/area",
    addVehiclesByArea: "api/assign/vehicle/area",

    regionStatusChange: "api/region-status-change",
    zoneStatusChange: "api/zone-status-change",
    areaStatusChange: "api/area-status-change",

    getAllRegionByUser: "api/get/user/region/hierarchy",
    assignTerritoryToUser: "api/assign/user/region/zone/area",

    getAllAreasForAssigningUser: "api/get-all/areas/by/zoneIds",

    removeVehicleFromArea: "api/remove/vehicles/area",
    removeAssignedRegion: "api/deactivate/user/region",

    assignLocksToArea: "api/assign/locks/area",
    removeLocksFromArea: "api/remove/locks/area",
    getAllLocksForArea: "api/locks/area/",
    // ==============================Lock Inventory======================
    LockDashboardAll: "lock/dashboard/tracking-data",
    LockGetAll: "api/v1/locks/core/v1/getAll",
    LockAdd: "api/v1/locks/add",
    LockLinkVehicle: "api/v1/locks/link-vehicle",
    LockUnlink: "api/v1/locks/unlink",
    LockUsers: "api/lock/users",
    LockAssignToUser: "api/assign/user/lock",
    LockGetAllByUser: "api/user/locks",
    LockUnAssign: "api/unassign/user/lock",
    LockDetail: "lock/dashboard/single/lock/data",
    LockType: "all/elock/type",
    GetAllFixedLock: "api/v1/locks/core/v1/getAll/fixed-lock",
    LockUpdate: "api/v1/locks/update-sim-rfid",
    LockTrail: "api/v1/locks/sim-rfid-trail",
    UpdateLockMode: "api/elock/convert/strict-nonstrict",
    StrictModeTrail: "api/get/all/order/strict/trails",
    LockUserDetails: "api/v1/locks/user-details",

    // ==============================Lock Dashboard======================
    LockDashboardStatus: "api/v1/locks/dashboard",
    LockTamperingStatus: "api/v1/locks/getTamperingStatus",
    LockAnalyticsData: "lock/dashboard/analytics-lock-status",
    LockTripStatus: "lock/dashboard/analytics-lock-trip-status",
    LockTripCompleteionGraph: "lock/dashboard/trip/completion/graph",
    LockDashboardTripAnalytics: "lock/dashboard/trip/analytics",
    LockHistory: "lock/dashboard/lock/open/history",
    LockAlertCount: "get/elock/alert/count",
    LockAlertsGetAll: "get/all/alert",
    getLiveDeviceRoutesGeofences: "api/get/all/routes-geofences",
    // ==============================Trip V2======================
    TripV2GetAll: "api/v2/etp/orders/get/all",
    TripV2Add: "api/elock/create/manual/trip",
    SCMTripAdd:"api/elock/trip/create",
    TripV2Update: "api/v1/trips/update",
    // TripV2Delete: "api/v1/trips/delete",
    TripV2Start: "api/v1/trips/start",
    TripV2StartManual: "api/elock/start/manual/trip",
    TripV2DeleteManual: "api/elock/cancel/manual/trip",
    TripV2End: "api/v1/trips/end",
    TripV2ById: "api/v1/etp/orders/view",
    TripV2CheckValidation: "api/elock/check/trip/validation",
    // DigitalLockUnlockExport:"e-lock/system-trips/export/reports/page/data",
    DigitalLockUnlockExport: "e-lock/export/trail/data",
    LockTripsExport: "v1/exports/trip/page/data",

    // ==============================Route V2======================
    RouteV2GetAll: "api/v5/route/getAll",
    RouteV2Add: "api/v5/route/add",
    RouteV2Update: "api/v5/route/update",
    RouteV2Delete: "api/v5/route/delete",
    RouteV2ById: "api/v5/route",
    RouteAlertType: "get/all/route/alert-type",
    RouteDelete: "delete/route/alert",
    Routev6GetAll: "api/v6/route/getAll",

    // sendLockOpt: "api/v1/verify/number/request",
    sendLockOpt: "api/elock/v1/send/otp/request",

    verifyOtp: "api/elock/v1/verify/otp",
    tripvalidation: "api/check/trip/validation",
    tripDetailstLock:"api/elock/trip/prepare",

    // ========================= PERMISSIONS =======================

    getAllMasterPermissionsByType: "api/v1/get/all/master/permission",
    getUserWiseMasterPermissionsByType: "api/v1/get/user/master/config",
    saveUserWiseMasterPermissionsByType: "api/v1/save/user/master/config",
    getLockPermissionsForTrips: "api/v1/locks/by/id",
    saveLockPermissionsForTrips: "api/v1/locks/update/configurations",
    getDealerCustomerWisePermissionsForTrips: "api/get/user/lock/permission",
    saveDealerCustomerPermissionsForTrips: "api/modify/user/lock/permission",
    getUserWiseGpsPermission: "v1/user/gps/permission",
    saveUserWiseGpsPermission: "modify/user/gps/permission",
    getAllFaqCategories: "api/faq/v2/category/all",
    saveUpdateFaqCategory: "api/faq/v1/category/saveOrUpdate",
    getAllFaqQuestionsByCategory: "api/faq/v2/question/getByCategory",
    saveUpdateFaqQuestion: "api/faq/v1/question/saveOrUpdate",
    getAllFaqAnswersByQuestion: "api/faq/v2/answer/getByQuestion",
    saveUpdateFaqAnswer: "api/faq/v1/answer/saveOrUpdate",
    getAllExcises: "api/elock/get/all/excise",

    // ========================= FAQ =================================
    getAllFaqCategory: "api/faq/v1/category/all",
    getAllFaqQuestions: "api/faq/v1/question/getByCategory",
    getAllFaqAnswers: "api/faq/v1/answer/getByQuestion",
    saveFuelCalibration: "fuel-service/api/v1/fuel/calibration/",

    sendMobileOtp: "api/v1/verify/number/request",
    verifyMobileOtp: "api/v1/verify/otp",


    fuelIntelOverview: "fuel-service/api/v1/fuel/intel/overview",
    fuelIntelDaily: "fuel-service/api/v1/fuel/intel/daily",
    fuelIntelLevelGraph: "fuel-service/api/v1/fuel/intel/level-graph",
    fuelIntelEvents: "fuel-service/api/v1/fuel/intel/events",
    fuelIntelSensorHealth: "fuel-service/api/v1/fuel/intel/sensor-health",
    fuelIntelMap: "fuel-service/api/v1/fuel/intel/map",
    fuelIntelHotspots: "fuel-service/api/v1/fuel/intel/hotspots",
    fuelIntelVehicles: "fuel-service/api/v1/fuel/intel/vehicles",
    fuelIntelFormulas: "fuel-service/api/v1/fuel/intel/formulas",

    // ========================= SMS =================================
    getSmsLogs: "api/sms-logs",
    updateTopupForLockSms: "api/sms-logs/topup",
    updateTopupForGpsSms: "api/sms-logs/topup"
  },
};
